// should be the same as in launchDarkly UI flag 'key' value
export enum LaunchDarklyFlags {
  FE_TEST = "lmn-pro-fe-test",
  WEB_BASED_PROPOSAL_MVP = "lp-2003-web-based-proposal-mvp",
  ADDITIONAL_HIDE_SHOW_OPTIONS = "lp-3260-additional-hide-show-options-web-proposals",
  LP_4114_STALE_CHUNK_FIX = "lp-4114-stale-chunk-fix",
  LP_4443_PROCESSING_FEES = "lp-4443-processing-fees",
  LP_5629_NEW_INVOICE_FORMAT = "lp-5629-new-invoice-format",
  LP_4235_WORK_AREA_VISIBILITY_CONTROLS = "lp-4235-work-area-visibility-controls",
  LP_4912_PDF_PREVIEW = "lp-4912-pdf-preview",
  LP_3645_ENABLE_SERVICE_WEB_PROPOSALS = "lp-3645-enable-service-web-proposals",
  LP_5959_DECOUPLING_SERVICE_ESTIMATE_CUSTOMIZATION = "lp-5959-decoupling-service-estimate-customization",
  LP_3435_OPTIONALITY = "lp-3435-optionality",
  LP_6323_BILLED_PER_MONTH_CUSTOMIZATIONS = "lp-6323-billed-per-month-customizations",
  LP_7876_SERVICE_TOTALS_GROUP = "lp-7876-service-totals-group",
  LP_6440_WEB_PROPOSAL_ACORN_FINANCING = "lp-6440-web-proposal-acorn-financing",
  LP_6769_WORK_AREA_TOTAL_CLIENT_VIEW = "lp-6769-workarea-total-toggle-standard-client-view",
  LP_7494_ITEM_FIELD_VISIBILITY = "lp-7494-standard-proposal-per-itemtype-field-visibility",
  LP_7708_WEB_PROPOSAL_LINE_ITEM_TABLE = "lp-7708-web-proposal-line-item-table",
}
